import {
  CModal,
  CModalBody,
  CModalTitle,
  CModalHeader,
  CModalFooter,
  CButton,
} from "@coreui/react"
import { useEffect, useState } from "react"
import { getRaceParticipants, setRaceResult } from "src/store/Slices/UsersRatingSlice"
import { useDispatch, useSelector } from "react-redux"
import { Select, Input, Table, message } from "antd"
import { DeleteOutlined } from "@ant-design/icons"

const SetRaceResult = ({ visible, setVisible, raceId }) => {
  const dispatch = useDispatch()
  
  const [selectedParticipant, setSelectedParticipant] = useState(null)
  const [resultTime, setResultTime] = useState("")
  const [resultsList, setResultsList] = useState([])
  const [loading, setLoading] = useState(false)
  const [payloadVariant, setPayloadVariant] = useState(1)

  const raceParticipants = useSelector(
    (state) => state.UsersRatingSlice?.racePatisipantsList,
  )

  useEffect(() => {
    if (visible && raceId) {
      dispatch(getRaceParticipants(raceId))
      setResultsList([])
      setSelectedParticipant(null)
      setResultTime("")
    }
  }, [visible, dispatch, raceId])

  const participantOptions =
    raceParticipants?.data?.value?.rows?.map((element) => ({
      label: element?.fio || element?.phoneNumber || `Участник ${element?.id}`,
      value: element?.id,
      ...element,
    })) || []

  const handleAddResult = () => {
    if (!selectedParticipant) {
      message.warning("Выберите участника")
      return
    }
    
    if (!resultTime || isNaN(resultTime) || Number(resultTime) <= 0) {
      message.warning("Введите корректное время (число)")
      return
    }

    if (resultsList.some(item => item.userId === selectedParticipant.userId)) {
      message.warning("Этот участник уже добавлен")
      return
    }

    setResultsList([
      ...resultsList,
      {
        userId: selectedParticipant.userId || selectedParticipant.id,
        fio: selectedParticipant.fio,
        phoneNumber: selectedParticipant.phoneNumber,
        position: resultsList.length + 1,
        points: Number(resultTime),
      },
    ])

    setSelectedParticipant(null)
    setResultTime("")
    message.success("Результат добавлен")
  }

  const handleRemoveResult = (userId) => {
    const newList = resultsList.filter(item => item.userId !== userId)
    const updatedList = newList.map((item, index) => ({
      ...item,
      position: index + 1,
    }))
    setResultsList(updatedList)
    message.success("Результат удален")
  }

  const getPayload = () => {
    const baseParticipants = resultsList.map(item => ({
      userId: item.userId,
      position: item.position,
      points: item.points,
    }))

    const baseParticipantsBig = resultsList.map(item => ({
      UserId: item.userId,
      Position: item.position,
      Points: item.points,
    }))

    switch(payloadVariant) {
      case 1:
        return {
          raceId: raceId,
          participants: baseParticipants
        }
      
      case 2:
        return {
          RaceId: raceId,
          Participants: baseParticipantsBig
        }
      
      case 3:
        return baseParticipants
      
      case 4:
        return baseParticipantsBig
      
      case 5:
        return resultsList.map(item => ({
          raceId: raceId,
          userId: item.userId,
          position: item.position,
          points: item.points,
        }))
      
      case 6:
        return resultsList.map(item => ({
          RaceId: raceId,
          UserId: item.userId,
          Position: item.position,
          Points: item.points,
        }))
      
      case 7:
        return {
          raceId: raceId,
          list: baseParticipants
        }
      
      case 8:
        return {
          raceId: raceId,
          items: baseParticipants
        }
      
      case 9:
        return {
          raceId: raceId,
          data: baseParticipants
        }
      
      case 10:
        return {
          data: {
            raceId: raceId,
            participants: baseParticipants
          }
        }
      
      case 11:
        return {
          raceId: raceId,
          participants: {
            value: baseParticipants
          }
        }
      
      case 12:
        return {
          raceId: raceId,
          participants: {
            rows: baseParticipants
          }
        }
      
      default:
        return {
          raceId: raceId,
          participants: baseParticipants
        }
    }
  }

  const handleSubmit = async () => {
    if (resultsList.length === 0) {
      message.warning("Добавьте хотя бы один результат")
      return
    }

    setLoading(true)
    
    try {
      const payload = getPayload()
      console.log(`=== ВАРИАНТ ${payloadVariant} ===`)
      console.log("Отправляем:", JSON.stringify(payload, null, 2))
      
      const result = await dispatch(setRaceResult(payload))
      console.log("Ответ:", result)
      
      if (result.payload?.data?.isSuccess) {
        message.success("Результаты успешно сохранены")
        handleClose()
      } else {
        const errorMsg = result.payload?.data?.errorMessages?.[0]?.errorMessage || 
                         result.payload?.data?.message || 
                         "Ошибка при сохранении результатов"
        message.error(errorMsg)
      }
    } catch (error) {
      console.error("Ошибка:", error)
      message.error("Ошибка при сохранении результатов")
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setVisible(false)
    setSelectedParticipant(null)
    setResultTime("")
    setResultsList([])
  }

  const columns = [
    {
      title: "Позиция",
      dataIndex: "position",
      key: "position",
      width: 80,
    },
    {
      title: "Участник",
      dataIndex: "fio",
      key: "fio",
      render: (text, record) => text || record.phoneNumber || `Участник ${record.userId}`,
    },
    {
      title: "Телефон",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Очки",
      dataIndex: "points",
      key: "points",
      render: (points) => `${points}`,
    },
    {
      title: "Действия",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <CButton
          size="sm"
          color="danger"
          variant="ghost"
          onClick={() => handleRemoveResult(record.userId)}
          style={{ padding: "4px 8px" }}
        >
          <DeleteOutlined />
        </CButton>
      ),
    },
  ]

  return (
    <CModal
      alignment='center'
      visible={visible}
      onClose={handleClose}
      keyboard={true}
      size='lg'
    >
      <CModalHeader>
        <CModalTitle>Подведение результатов</CModalTitle>
      </CModalHeader>
      
      <CModalBody>
        <div style={{ padding: "10px 0" }}>
       
          <div style={{ display: "flex", gap: "10px", marginBottom: "20px", alignItems: "center" }}>
            <Select
              placeholder='Выберите участника'
              style={{ flex: 1, height: "32px" }}
              options={participantOptions}
              value={selectedParticipant?.value}
              onChange={(value, option) => setSelectedParticipant(option)}
              showSearch
              loading={!participantOptions.length && visible}
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
            />
            
            <Input
              placeholder='Очки'
              type='number'
              value={resultTime}
              onChange={(e) => setResultTime(e.target.value)}
              style={{ width: "150px", height: "32px" }}
              onPressEnter={handleAddResult}
            />
            
            <CButton
              color='primary'
              onClick={handleAddResult}
              style={{ color: "#fff", minWidth: "100px", height: "32px" }}
            >
              Добавить
            </CButton>
          </div>

          {resultsList.length > 0 && (
            <div style={{ marginTop: "15px" }}>
              <div style={{ 
                marginBottom: "10px", 
                fontWeight: 500,
                fontSize: "14px",
                color: "#262626"
              }}>
                Добавленные результаты ({resultsList.length})
              </div>
              <Table
                size="small"
                columns={columns}
                dataSource={resultsList}
                rowKey="userId"
                pagination={false}
                bordered
              />
            </div>
          )}
        </div>
      </CModalBody>
      
      <CModalFooter>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
          <div style={{ fontSize: "14px", color: "#666" }}>
            {resultsList.length > 0 && `Добавлено результатов: ${resultsList.length}`}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <CButton color='secondary' onClick={handleClose}>
              Отмена
            </CButton>
            <CButton
              color='primary'
              style={{ color: "#fff" }}
              onClick={handleSubmit}
              disabled={resultsList.length === 0 || loading}
            >
              {loading ? "Сохранение..." : "Сохранить результаты"}
            </CButton>
          </div>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default SetRaceResult